import { Link, useParams } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import CategoryView from "@/pages/blog/components/CategoryView";
import ArticleView from "@/pages/blog/components/ArticleView";
import { getCategory, getPost } from "@/pages/blog/blogData";

function BlogNotFound({ slug }: { slug: string }) {
  return (
    <SiteLayout>
      <Seo
        title="Conteúdo não encontrado | Blog NXHOST"
        description="O conteúdo que você procura não foi encontrado no blog da NXHOST. Explore as categorias ou use a busca."
        path={`/blog/${slug}`}
      />
      <section className="bg-foreground-950 text-background-50">
        <div className="mx-auto w-full max-w-7xl px-4 pt-32 pb-20 text-center md:px-8 md:pt-40">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-background-50/15 bg-background-50/5 text-accent-300">
            <i className="ri-file-search-line text-3xl" aria-hidden="true"></i>
          </span>
          <h1 className="mt-6 font-heading text-3xl font-bold md:text-4xl">Conteúdo não encontrado</h1>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-background-200">
            O artigo ou categoria que você procurou não existe ou o endereço foi alterado.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-article-line" aria-hidden="true"></i>
              Voltar para o blog
            </Link>
            <Link
              to="/contato"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/20 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              Falar com a NXHOST
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}

export default function BlogEntry() {
  const { slug = "" } = useParams();

  const category = getCategory(slug);
  if (category) return <CategoryView category={category} />;

  const post = getPost(slug);
  if (post) return <ArticleView post={post} />;

  return <BlogNotFound slug={slug} />;
}